import gql from "graphql-tag"

const fragment = gql`
fragment fullSavedCard on PaymentSavedCard {
  reference
  expiry {
    month
    year
  }
  number
  holder {
    name
  }
  variant
}
`

export const toString = fragment.loc.source.body

export default fragment
